import type { AiAppCenterModule } from '../types'

export const eventModule: AiAppCenterModule = {
  key: 'event',
  label: '赛事管理',
  desc: '赛事创建 / 赛程编排 / 成绩管理',
  path: '/event',
  homePath: '/event/analytics',
  icon: 'ep:trophy',
  color: '#d98e00'
}
